import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Typography } from '@/components/Typography';
import { px2rem } from '@/theme';

import { ReactComponent as LogoSvg } from '@/assets/breitling-simple.svg';
import { ReactComponent as InfoBadge } from '@/assets/icons/info-badge.svg';

export const Wrapper = styled(Box)<{ $loading: boolean }>`
  ${({ $loading }) =>
    $loading &&
    css`
      visibility: hidden;
    `}
`;

export const Badge = styled(InfoBadge)`
  ${({ theme }) => css`
    width: ${px2rem(12)};
    margin-left: ${theme.spacing(1)};
  `}

  &:hover {
    cursor: pointer;
  }
`;

export const Logo = styled(LogoSvg)`
  width: 50px;
  margin: ${({ theme }) => theme.spacing(2)};
`;

export const Body = styled(Typography)`
  text-align: center;
  max-width: 700px;
  line-height: 25px;

  ${({ theme }) => css`
    font-weight: ${theme.fontWeights.regular};
    margin: 0 auto ${theme.spacing(2)};
    scale: ${theme.fontSizes.p0};
    color: ${theme.colors.defaultAdd3};
  `}
`;
